// language=GraphQL
const userProfile = `
  query
    userProfile {
      userProfile {
        profile {
          customerId
          email
        }
      }
    }
`;

export default userProfile;
